export enum TableNames {
  HtmlTemplate = 'htmltemplatesv1',
  KeyValueStore = 'KeyValueStore',
  HtmlStorage = 'HtmlStorage',
  HtmlTemplateConfig = 'htmltemplateconfigv1'
}
